export const SETTINGS = {
    TOS_VALID_DATE: {
        commercePlatform: '1970-07-04T06:00:00.001Z'
    },
    PREFERRED_APPS: [
        'ful',
        'fulmon',
        'tnc',
        'tracker',
        'devcen',
        'webxd',
    ],
    LOCALIZATION_OPTIONS: {
        languages: {
            'en-US': 'English',
            'fr-FR': 'French',
            'fr-CA': 'French (Canada)',
            'zh-CN': 'Chinese (Simplified)',
            'zh-TW': 'Chinese (Traditional)',
            'es-ES': 'Spanish'
        },
        locales: {
            'zh-CN': 'Chinese (Simplified)',
            'zh-TW': 'Chinese (Traditional)',
            'en-AU': 'English (Australia)',
            'en-CA': 'English (Canada)',
            'en-HK': 'English (Hong Kong)',
            'en-IE': 'English (Ireland)',
            'en-IN': 'English (India)',
            'en-PH': 'English (Philipines)',
            'en-GB': 'English (United Kingdom)',
            'en-US': 'English (US 12 hour)',
            'en-US24': 'English (US 24 hour)',
            'en-SG': 'English (Singapore)',
            'fr-FR': 'French',
            'fr-CA': 'French (Canada)',
            'es-ES': 'Spanish',
        },
        localized: {
            languages: {
                'zh-CN': '简体字',
                'zh-TW': '繁體字',
                'en-US': 'English',
                'fr-FR': 'Français',
                'fr-CA': 'Français Canadien',
                'es-ES': 'Español',
            },
            locales: {
                'zh-CN': '简体字',
                'zh-TW': '繁體字',
                'en-AU': 'English (Australia)',
                'en-CA': 'English (Canada)',
                'en-HK': 'English (Hong Kong)',
                'en-IE': 'English (Ireland)',
                'en-IN': 'English (India)',
                'en-PH': 'English (Philipines)',
                'en-GB': 'English (United Kingdom)',
                'en-US': 'English (US 12 hour)',
                'en-US24': 'English (US 24 hour)',
                'en-SG': 'English (Singapore)',
                'fr-FR': 'Français',
                'fr-CA': 'Français Canadien',
                'es-ES': 'Español',
            }
        }
    },
    REGION_MAPS: {
        contactData: {
            us: {
                phone: '612-249-0431',
                tollFree: '866-245-8100'
            },
            china: {
                phone: '+86 4006-233-251'
            },
            australia: {
                phone: '1300 532 383'
            },
            seasonal_hold: {
                phone: '866.245.8100',
                option: '2'
            },
            suspension: {
                phone: '888.739.3232',
                option: '4'
            }
        },
        notificationKeys: {
            'suspension-warning': 'cp.subscription.warningNonAPAC',
            'suspension-warning-apac': 'cp.subscription.warningAPAC',
            'suspended': 'cp.subscription.suspendedNonAPAC',
            'suspended-apac': 'cp.subscription.suspendedAPAC',
            'seasonal-hold': 'cp.subscription.seasonalHoldNonAPAC',
            'seasonal-hold-apac': 'cp.subscription.seasonalHoldAPAC'
        },
        timezones: {
            apac: {
                asia: [
                    'Colombo',
                    'Kolkata',
                    'Kathmandu',
                    'Almaty',
                    'Dhaka',
                    'Omsk',
                    'Thimphu',
                    'Urumqi',
                    'Rangoon',
                    'Yangoon',
                    'Bangkok',
                    'Ho_Chi_Minh',
                    'Hovd',
                    'Jakarta',
                    'Phnom_Penh',
                    'Pontianak',
                    'Saigon',
                    'Vientiane',
                    'Brunei',
                    'Choibalsan',
                    'Dornod',
                    'Chongqing',
                    'Chungking',
                    'Harbin',
                    'Hong_Kong',
                    'Kuala_Lumpur',
                    'Kuching',
                    'Macao',
                    'Macau',
                    'Makassar',
                    'Manila',
                    'Shanghai',
                    'Singapore',
                    'Taipei',
                    'Ujung_Pandang',
                    'Ulaanbaatar',
                    'Ulan_Bator',
                    'Dili',
                    'Jayapura',
                    'Pyongyang',
                    'Seoul',
                    'Tokyo'
                ],
                indian: [
                    'Chagos',
                    'Cocos',
                    'Christmas'
                ],
                australia: [
                    'NZ-CHAT',
                    'ROK',
                    'Eucla',
                    'Adelaide',
                    'Broken_Hill',
                    'Darwin',
                    'Brisbane',
                    'Currie',
                    'Hobart',
                    'Linderman',
                    'Melbourne',
                    'Sydney',
                    'Lord_Howe',
                    'West',
                    'North',
                    'South',
                    'Yancowinna',
                    'ACT',
                    'Canberra',
                    'NSW',
                    'Queensland',
                    'Tasmania',
                    'Victoria'
                ],
                pacific: [
                    'Palau',
                    'Chuuk',
                    'Guam',
                    'Port_Moresby',
                    'Saipan',
                    'Truk',
                    'Yap',
                    'LHI',
                    'Bougainville',
                    'Efate',
                    'Guadalcanal',
                    'Kosrae',
                    'Norfolk',
                    'Noumea',
                    'Pohnpei',
                    'Auckland',
                    'Fiji',
                    'Funafuti',
                    'Kwajalein',
                    'Majuro',
                    'Nauru',
                    'Tarawa',
                    'Wake',
                    'Wallis',
                    'Chatham Chatham Islands',
                    'Apia',
                    'Enderbury',
                    'Fakaofo',
                    'Tongatapu',
                    'Kiritimati',
                    'ROK',
                    'ROC',
                    'Kwajalein'
                ],
                etc: [
                    'GMT-6',
                    'GMT-7',
                    'GMT-8',
                    'GMT-9',
                    'GMT-10',
                    'GMT-11',
                    'GMT-12',
                    'GMT-13',
                    'GMT-14'
                ]
            }
        }
    }
};
